// Bundle page (Rebuy bundle builder), loaded only on page.bundle-page.
(() => {
  // 1. The "My bundle" panel sticks in the vertical middle of the screen. Its height changes as products are added,
  //    so keep it in a CSS variable the sticky `top` is worked out from (custom.css).
  const watchPanel = (panel) => {
    if (panel.dataset.stickyWatched) return;
    panel.dataset.stickyWatched = 'true';
    new ResizeObserver(() => {
      panel.style.setProperty('--rival-bundle-panel-height', `${panel.offsetHeight}px`);
    }).observe(panel);
  };

  // 2. Rebuy asks Shopify for 400x400 images, which come out ~267px wide for portrait photos and look blurry at
  //    330px on retina screens. Ask for 1000px wide instead.
  const SIZE = /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande)(?=\.(jpe?g|png|webp|gif)(\?|$))/i;
  const sharpen = (img) => {
    const src = img.getAttribute('src');
    if (!src || !src.includes('cdn.shopify.com') || !SIZE.test(src)) return;
    const sharp = src.replace(SIZE, '_1000x');
    if (sharp !== src) img.setAttribute('src', sharp);
  };

  const update = () => {
    document.querySelectorAll('.rebuy-bundle-builder__group-container').forEach(watchPanel);
    document.querySelectorAll('.rebuy-bundle-builder img').forEach(sharpen);
  };

  // Rebuy renders (and re-renders) the builder after load
  new MutationObserver(update).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src'],
  });
  update();
})();
